



































































import { Component, Vue } from 'vue-property-decorator'
import Toast from '@/app/components/Common/Toast.vue'
/* api */
import LogoutApi from '@/app/model/api/logoutApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { routerPath, userType } from '@/app/model/store/domain/const'

@Component({
  components: {
    Toast
  }
})
export default class HeaderMenu extends Vue {
  private showAuth: boolean = true
  private showErrorAlert: boolean = false
  private toastMessage: string = ''

  created () {
    if (parseInt(Local.getUserType()!) === userType.USER_TYPE_ADMIN) {
      this.showAuth = false
    }
  }

  private async doLogout () {
    CommonClass.doLogout()
  }
}
